import React from 'react';

import TermsText from './components';
import s from './LegalsMentions.module.scss';

const LegalsMentions = () => {
  return (
    <div className={s.container}>
      <div className={s.title}>General Terms and Conditions</div>
      <div className={s.content}>
        {/* <div className={s.cookies}>Cookies</div>
        <div className={s.devider} /> */}
        <div className={s.text}>
          <TermsText />
        </div>
      </div>
    </div>
  );
};

export default LegalsMentions;
